import data from "../../../../../platform_common_constants/layout_flow_constants.json";
export const LayoutFlowConstants = data;
